class FFAnnouncementSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.ff-announcement-slider__viewport');
    this.slides = Array.from(this.querySelectorAll('.ff-announcement-slider__slide'));
    if (!this.viewport || this.slides.length <= 1) return;

    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.currentIndex < 0) this.currentIndex = 0;

    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.autoplay = this.dataset.autoplay !== 'false';
    this.timer = null;
    this.isTransitioning = false;

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.startAutoplay());

    if (this.autoplay) this.startAutoplay();
  }

  disconnectedCallback() {
    this.pause();
  }

  goTo(index) {
    if (this.isTransitioning || this.slides.length <= 1) return;

    const nextIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    if (nextIndex === this.currentIndex) return;

    this.isTransitioning = true;
    const currentSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[nextIndex];

    currentSlide.classList.remove('is-active');
    currentSlide.classList.add('is-leaving');

    nextSlide.classList.add('is-entering');
    nextSlide.classList.add('is-active');

    window.setTimeout(() => {
      currentSlide.classList.remove('is-leaving');
      nextSlide.classList.remove('is-entering');
      this.currentIndex = nextIndex;
      this.isTransitioning = false;
    }, 500);
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length <= 1) return;
    this.pause();
    this.timer = window.setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.speed);
  }

  pause() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('ff-announcement-slider')) {
  customElements.define('ff-announcement-slider', FFAnnouncementSlider);
}
